'use strict';

export function init() {
    const eventHeader = document.querySelector('.js-event-header');
    const eventSticky = document.querySelector('.event-sticky');
    const contentBlocks = document.querySelector('.content-blocks');
    const eventHeaderMedia = document.querySelector('.event-header__media');

    if (eventHeader && eventSticky && contentBlocks) {
        const myScrollFunc = function() {
            const rect = contentBlocks.getBoundingClientRect();
            let triggerPoint;
            // Setting a manuial trigger point if there is no image on the event page
            // This will stop the event navigation from being stuck open.
            if (eventHeaderMedia) {
                triggerPoint = window.innerHeight / 2;
            } else {
                triggerPoint = 100;
            }

            if (rect.top <= triggerPoint) {
                eventSticky.classList.add('show');
            } else {
                eventSticky.classList.remove('show');
            }
        };

        window.addEventListener('scroll', myScrollFunc, { passive: true });
    }
}
